import { type FirebaseApp, initializeApp } from 'firebase/app';
import { type Analytics, getAnalytics, isSupported } from 'firebase/analytics';

let app: FirebaseApp | null = null;
let analytics: Analytics | null = null;
let initPromise: Promise<Analytics | null> | null = null;

const firebaseConfig = {
  apiKey: import.meta.env.VITE_FIREBASE_API_KEY as string | undefined,
  authDomain: import.meta.env.VITE_FIREBASE_AUTH_DOMAIN as string | undefined,
  projectId: import.meta.env.VITE_FIREBASE_PROJECT_ID as string | undefined,
  storageBucket: import.meta.env.VITE_FIREBASE_STORAGE_BUCKET as string | undefined,
  messagingSenderId: import.meta.env.VITE_FIREBASE_MESSAGING_SENDER_ID as string | undefined,
  appId: import.meta.env.VITE_FIREBASE_APP_ID as string | undefined,
  measurementId: import.meta.env.VITE_FIREBASE_MEASUREMENT_ID as string | undefined,
};

const isConfigured = (): boolean => {
  return !!(firebaseConfig.apiKey && firebaseConfig.projectId && firebaseConfig.appId);
};

export const initFirebaseAnalytics = (): Promise<Analytics | null> => {
  if (initPromise) return initPromise;

  initPromise = (async () => {
    if (!isConfigured()) return null;

    try {
      const supported = await isSupported();
      if (!supported) return null;

      app = initializeApp(firebaseConfig);
      analytics = getAnalytics(app);
      return analytics;
    } catch {
      return null;
    }
  })();

  return initPromise;
};

export const getFirebaseAnalytics = (): Analytics | null => analytics;
